import instance from "../config/axios";
import { base_apis } from "../config/url";

export const getTicketList = (data) => {
    return instance.post(`${base_apis.tickets}/list`, data)
        .then((res) => {
            return res;
        });
};


export const getTicketDetails = (data) => {
    return instance.post(`${base_apis.tickets}/get/${data}`)
        .then((res) => {
            return res;
        });
};

export const createTicket = (data) => {
    return instance.post(`${base_apis.tickets}/create`,data)
        .then((res) => {
            return res;
        });
};

export const updateConversation = (data) => {
    return instance.post(`${base_apis.tickets}/update/${data?._id}`,data)
        .then((res) => {
            return res;
        });
};